import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const [form, setForm] = useState({
    name: "", email: "", emailConfirm: "", whatsapp: "",
    city: "", country: "Guatemala", password: "", passwordConfirm: "",
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.email.trim().toLowerCase() !== form.emailConfirm.trim().toLowerCase()) {
      toast.error("Los correos no coinciden");
      return;
    }
    if (form.password !== form.passwordConfirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (form.password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    setLoading(true);
    try {
      await register({
        name: form.name.trim(),
        email: form.email.trim(),
        whatsapp: form.whatsapp.trim(),
        city: form.city.trim(),
        country: form.country.trim(),
        password: form.password,
      });
      toast.success("Cuenta creada");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex flex-col hero-glow px-6 py-8" data-testid="register-page">
      <img src={LOGO_URL} alt="NEO ACADEMY" className="mx-auto w-32 h-32 object-contain" />
      <div className="text-center">
        <h1 className="font-heading text-2xl font-extrabold text-[#0A2A66]">Crea tu cuenta</h1>
        <p className="text-slate-600 text-sm mt-1">Empieza tu viaje educativo hoy</p>
      </div>

      <form onSubmit={submit} className="mt-5 space-y-3 w-full max-w-sm mx-auto">
        <FormField label="Nombre completo" testid="reg-name" value={form.name} onChange={set("name")} required />
        <FormField label="WhatsApp" testid="reg-whatsapp" type="tel" placeholder="+502 5555 5555" value={form.whatsapp} onChange={set("whatsapp")} required />
        <FormField label="Correo electrónico" testid="reg-email" type="email" value={form.email} onChange={set("email")} required />
        <FormField label="Confirmar correo" testid="reg-email-confirm" type="email" value={form.emailConfirm} onChange={set("emailConfirm")} required />
        <div className="grid grid-cols-2 gap-3">
          <FormField label="Ciudad" testid="reg-city" value={form.city} onChange={set("city")} required />
          <FormField label="País" testid="reg-country" value={form.country} onChange={set("country")} required />
        </div>
        <FormField label="Contraseña" testid="reg-password" type="password" value={form.password} onChange={set("password")} required />
        <FormField label="Confirmar contraseña" testid="reg-password-confirm" type="password" value={form.passwordConfirm} onChange={set("passwordConfirm")} required />

        <button
          type="submit"
          disabled={loading}
          data-testid="register-submit"
          className="gold-btn w-full py-3.5 mt-2 disabled:opacity-60"
        >
          {loading ? "Creando cuenta..." : "Crear mi cuenta"}
        </button>
      </form>

      <p className="text-center text-sm text-slate-600 mt-4">
        ¿Ya tienes cuenta?{" "}
        <Link to="/login" className="font-semibold text-[#1E5FD9]" data-testid="go-login">
          Inicia sesión
        </Link>
      </p>
    </main>
  );
}

function FormField({ label, testid, ...rest }) {
  return (
    <div>
      <label className="text-xs font-semibold text-[#0A2A66] uppercase tracking-wider">{label}</label>
      <input {...rest} data-testid={testid} className="input-clean mt-1" />
    </div>
  );
}
